/**
 * コモンクラス
 * @constructor
 */
class Common {
  constructor() {
  }
  /**
   * コモン
   */
  init() {
    // タブメニュー
    $('.js_btn1').on('click',(e) => {
      e.preventDefault();
      $('.js_btn1').addClass('active');
      $('.js_btn2').removeClass('active');
      $('.js_btn3').removeClass('active');
      $('.js_btn4').removeClass('active');
      $('.js-item1').show();
      $('.js-item2').hide();
      $('.js-item3').hide();
      $('.js-item4').hide();
    })
    $('.js_btn2').on('click',(e) => {
      e.preventDefault();
      $('.js_btn2').addClass('active');
      $('.js_btn1').removeClass('active');
      $('.js_btn3').removeClass('active');
      $('.js_btn4').removeClass('active');
      $('.js-item2').show();
      $('.js-item1').hide();
      $('.js-item3').hide();
      $('.js-item4').hide();
    })
    $('.js_btn3').on('click',(e) => {
      e.preventDefault();
      $('.js_btn3').addClass('active');
      $('.js_btn1').removeClass('active');
      $('.js_btn2').removeClass('active');
      $('.js_btn4').removeClass('active');
      $('.js-item3').show();
      $('.js-item1').hide();
      $('.js-item2').hide();
      $('.js-item4').hide();
    })
    $('.js_btn4').on('click',(e) => {
      e.preventDefault();
      $('.js_btn4').addClass('active');
      $('.js_btn1').removeClass('active');
      $('.js_btn2').removeClass('active');
      $('.js_btn3').removeClass('active');
      $('.js-item4').show();
      $('.js-item1').hide();
      $('.js-item2').hide();
      $('.js-item3').hide();
    })

    // アコーディオン
    $('.js-question').on('click', function () {
      $(this).next('.js-answer').slideToggle(500);
      if ($(this).children(".js-accordion").hasClass('open')) {
        $(this).children(".js-accordion").removeClass('open');
      } else {
        $(this).children(".js-accordion").addClass('open');
      }
      return false;
    });

  }
}

export default Common;
